
import { defineComponent, nextTick } from 'vue';
import { SocialProfile } from '@/models/Social/social-profile';
import { SocialMention } from '@/models/Social/social-mention';
import PrzLoader from '@/components/Muffin/Loader.vue';
import request from '@/Utilities/httpRequest';
import przHistory from '@/models/prz-history';
import Common from '@/components/Social/Mention/Common.vue';
import httpRequest from "@/Utilities/httpRequest";
import baseUrl from "@/api/base-url";
import {isEmpty} from "lodash-es";

export default defineComponent({
    components: {
        PrzMobile: () => import('@/components/Social/Mention/Mobile.vue'),
        PrzDesktop: () => import('@/components/Social/Mention/Desktop.vue'),
        PrzLoader
    },
    props: {
        ...Common.props,
        profile: {
            type: Object,
            default: undefined
        },
        profileObj: {
            type: SocialProfile,
            default: undefined
        },
        post:{
            type: Object,
            default: undefined
        },
        url:{
            type: String,
            default: undefined
        },
        isDesktop: {
            type: Boolean,
            default: false
        },
        isPdp: {
            type: Boolean,
            default: false
        },
        clubMode: {
            type: Boolean,
            default: false
        },
    },
    data(){
        let baseProfile: SocialProfile|undefined;
        let baseMention: SocialMention|undefined;
        let responseData: any|undefined;
        return {
            baseProfile,
            baseMention,
            lastUrlCall: '',
            isLoading: true,
            responseData,
            adjacentPostsPreload: null,
        }
    },
    watch:{
        url(newUrl){
            this.getMentionByUrl(newUrl)    ;
        }
    },
    mounted(){
        if(this.post && this.profile){
            this.createObjects(this.profile, this.post);
        }else if(this.url){
            this.getMentionByUrl(this.url);
        }
    },
    computed:{
        propsMention(): any{
            let notPass: Array<string> = ['profile','post','isDesktop','mention','url','profileObj'];
            let properties = {
                mention: this.baseMention
            };
            let defaultProps: any = {...Common.props};
            Object.entries(this.$props).forEach(([key, value], index) => {
                if(!notPass.includes(key)){
                    //if value in the props is the default or undefined || null, inject the value from the request
                    let responseValue = this.responseData && (key in this.responseData) ? this.responseData[key] : null;
                    let valueDefault  = defaultProps && (key in defaultProps) ? defaultProps[key].default : null;
                    let defaultValue  = typeof valueDefault == "function" ? valueDefault() : valueDefault;
                    let finalValue    = (value === undefined || value === null || JSON.stringify(defaultValue) == JSON.stringify(value)) && responseValue!==null ? responseValue : value;
                    properties  = {...properties,...{[key]:finalValue}};
                }
            });

            if(!isEmpty(this.adjacentPostsPreload)) {
                properties.preloadedPosts = this.adjacentPostsPreload;
            }

            return properties;
        }
    },
    methods: {
        reloadData({profile, post}){
            /*console.log('currentPost', post?.id);
            console.log('previousPost -> ', post?.previousPostId);
            console.log('nextPost -> ', post?.nextPostId);*/
            this.createObjects(profile, post);
        },
        createObjects(profile: any, post: any){
            if(post && profile){
                this.baseMention = this.getMention(profile, post);
                if(this.clubMode) {
                    this.setAdjacentPosts(profile, post);
                }
            }
            this.isLoading = false;
        },
        getProfile(profile: any): SocialProfile | undefined {
            if(this.profileObj){
                return this.profileObj;
            }
            return SocialProfile.create(profile,this.contentUrl,!this.isDesktop);
        },
        getMention(profile: any, post: any): SocialMention | undefined {
            this.baseProfile = this.getProfile(profile);
            if(this.baseProfile instanceof SocialProfile){
                return SocialMention.create(this.baseProfile,post);
            }
            return undefined;
        },
        async getMentionByUrl(mentionUrl: string|undefined){
            if(mentionUrl){
                let url = przHistory.formatUrl(mentionUrl);
                if(url == this.lastUrlCall){
                    this.$emit("loaded",this.baseMention);
                    return;
                }
                this.isLoading   = true;

                //Update the DOM
                await nextTick();

                this.lastUrlCall = url;
                let response = await request.get(url,null,false);
                if((response?.data?.hasError ?? null)){
                    this.$emit('close');
                    return;
                }
                this.responseData = response?.data ?? {};
                let post     = response?.data?.post ?? undefined;
                let profile  = response?.data?.profile ?? undefined;    
                this.createObjects(profile,post);

                //Update the DOM
                await nextTick();
                this.$emit("loaded",this.baseMention);
            }
        },
        async setAdjacentPosts(profile: any, post: any) {
            //console.log('in test POST CACHE');
            let requestUrl = baseUrl.getUrl('socialNetwork/post?oti=PDP_SOCIAL');
            let previousParams = {
                profileid: profile.id,
                postId: post.previousPostId,
                profilename: profile.nameId
            }

            let nextParams = {
                profileid: profile.id,
                postId: post.nextPostId,
                profilename: profile.nameId
            }

            const previousData = post.previousPostId ? await httpRequest.get(requestUrl, previousParams) : null;
            const nextData = post.nextPostId ? await httpRequest.get(requestUrl, nextParams) : null;

            this.adjacentPostsPreload = {
                previous: (previousData && !previousData.data.hasError) ? previousData.data : null,
                next: (nextData && !nextData.data.hasError) ? nextData.data : null,
            }

            if(this.isDesktop) {
                this.$emit('update-preloaded-posts', this.adjacentPostsPreload);
            }
        }
    }
});
